// extracted by mini-css-extract-plugin
module.exports = {"banks":"_9330de7794--banks--kLGn1"};